export const setFocus = (node) => {
  node.focus();
};